// ============================================
// SHARED PHYSICS CONSTANTS
// ============================================
// Single source of truth  -  never hardcode these values elsewhere.

/** Speed of light in m/s */
export const C = 299792458;

/** Speed of light in m/ns (convenient for TOF calculations) */
export const C_M_PER_NS = 0.299792;

/** Magnetic rigidity factor: r = p / (RIGIDITY_FACTOR �- B �- |q|), p in GeV/c, B in T, r in m */
export const RIGIDITY_FACTOR = 0.3;

/** Highland formula constant in MeV */
export const MCS_CONSTANT_MEV = 13.6;

/** Highland formula constant in GeV (= MCS_CONSTANT_MEV / 1000) */
export const MCS_CONSTANT_GEV = 0.0136;

/** Proton rest mass in GeV/c² */
export const PROTON_MASS = 0.93827;
